import React, { useEffect, useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import Form from 'react-bootstrap/Form';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from 'primereact/inputswitch';
import { useDropzone } from 'react-dropzone';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from "primereact/radiobutton";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import Loader from '../loader/loader'

//icons
import Edit from '../../assets/icons/edit.svg';
import Trash from '../../assets/icons/trash.svg';
import WhiteTrash from '../../assets/icons/white-trash.svg'
import Upload from '../../assets/icons/upload.svg'
import useToastNotification from '../../hooks/useToastNotification';
import { getRawBase64Data } from '../../utils/image';
import { baseUrl, CreateWeblogAndNews, DeleteWeblogAndNews, SearchWeblogAndNews, UpdateWeblogAndNews } from '../../utils/api';
import { confirmDialog } from 'primereact/confirmdialog';


function Banner() {
    const [addFormValidated, setAddFormValidated] = useState(false);
    const [editFormValidated, setEditFormValidated] = useState(false);
    const { showError, showSuccess } = useToastNotification();
    const typeId = 2; // 1=blogs , 2=news
    const [addVisible, setAddVisible] = useState(false);
    const [editvisible, setEditVisible] = useState(false);
    const [status, setStatus] = useState(false);
    const [catName, setCatName] = useState('');
    const [catNum, setCatNum] = useState('');
    const [text, setText] = useState('');
    const [loading, setLoading] = useState(false);

    const [title, setTitle] = useState("");
    const [idNews, setIdNews] = useState("");
    const [readingTime, setReadingTime] = useState("");
    const [showInLandingPage, setShowInLandingPage] = useState(true);


    const [uploadedFile, setUploadedFile] = useState([]);
    const [imagePreview, setImagePreview] = useState([]);
    const [uploadStatus, setUploadStatus] = useState(null);


    const [items, setItems] = useState([]);
    useEffect(() => {
        loadPage();
    }, []);
    const loadPage = async () => {
        await SearchWeblogAndNews({ typeId }).then(response => {
            if (response.data?.data?.items) {
                setItems(response.data?.data?.items);
            }
        });
    };


    const quillModules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],  // Headers & Fonts
            [{ 'size': ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px', '32px', '34px', '36px', '40px', '44px', '48px', '54px', '60px', '72px', '80px'] }],  // Custom font sizes
            ['bold', 'italic', 'underline', 'strike'],  // Formatting options
            ['blockquote', 'code-block'],  // Blockquote and code block
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],  // Lists
            [{ 'indent': '-1' }, { 'indent': '+1' }],  // Indentation
            [{ 'direction': 'rtl' }],  // Text direction (RTL)
            [{ 'align': [] }],  // Text alignment
            [{ 'color': [] }, { 'background': [] }],  // Text and background colors
            ['link', 'image', 'video'],  // Inserting links, images, and videos
            [{ 'script': 'sub' }, { 'script': 'super' }],  // Subscript/Superscript
            ['clean']  // Remove formatting
        ]
    };

    const quillFormats = [
        'header', 'font', 'size', 'bold', 'italic', 'underline', 'strike',
        'blockquote', 'code-block', 'list', 'bullet', 'indent',
        'link', 'image', 'video', 'align', 'color', 'background', 'direction'
    ];
    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });
    const onStatusChange = async (rowData, value) => {
        const convertToBase64 = async (file) => {
            return await toBase64(file).then(result =>
                result.substr(result.indexOf(",") + 1)
            );
        };

        // Initialize fileBase64
        let fileBase64 = null;

        if (rowData.logoPath) {
            // Fetch the file from the logoPath and convert to Base64
            try {
                const response = await fetch(baseUrl + "IO/" + rowData.logoPath); // Assuming `logoPath` is a URL
                const blob = await response.blob();
                fileBase64 = await convertToBase64(blob);
            } catch (error) {
                console.error("Error converting logoPath to Base64:", error);
                showError("مشکلی در تبدیل لوگو به Base64 وجود دارد.");
                setLoading(false);
                return;
            }
        }
        await UpdateWeblogAndNews({
            id: rowData.id, isActive: value,

            body: rowData.body,
            summery: rowData.summery,
            readTime: rowData.readTime,
            createUserId: 0,
            fileBase64: fileBase64,
            typeId: rowData.typeId,
            showInLandingPage: rowData.showInLandingPage,
        }).then(() => {
            const updatedItems = items.map(item =>
                item.id === rowData.id ? { ...item, isActive: value } : item
            );
            setItems(updatedItems);
            showSuccess("عملیات با موفقیت انجام شد");
        }).catch(error => showError(error.response.data.message || "خطایی رخ داد"));
    };

    const statusSwitchTemplate = (rowData) => {
        return (
            <InputSwitch
                checked={rowData.isActive}
                onChange={(e) => onStatusChange(rowData, e.value)}
            />
        );
    };

    const openAddDialog = () => {
        setLoading(false);
        setUploadStatus("");
        setAddVisible(true);
        document.body.style.overflow = 'hidden';
    };
    const closeAddDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        setUploadStatus("");
        setAddVisible(false);
        document.body.style.overflow = 'auto';
        // reset properties to default
        setImagePreview([]);
        setUploadedFile([]);
        setText("");
        setTitle("");
        setReadingTime("");
        setStatus(false);
    };

    const openEditDialog = (rowData) => {
        // set values
        setTitle(rowData.summery);
        setText(rowData.body);
        setReadingTime(rowData.readTime);
        setStatus(rowData.isActive);
        setIdNews(rowData.id);
        setShowInLandingPage(rowData.showInLandingPage);
        if (!!rowData.logoPath) {
            setImagePreview([baseUrl + "IO/" + rowData.logoPath]);
        }

        setLoading(false);
        setUploadStatus("");
        setEditVisible(true);
        document.body.style.overflow = 'hidden';
    };
    const closeEditDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        setUploadStatus("");
        setEditVisible(false);
        document.body.style.overflow = 'auto';
        // reset properties to default
        setImagePreview([]);
        setUploadedFile([]);
        setText("");
        setTitle("");
        setReadingTime("");
        setStatus(false);
    };


    const deleteItem = async (item) => {
        await DeleteWeblogAndNews({ id: item.id }).then(() => {
            showSuccess("عملیات با موفقیت انجام شد");
            setItems(old => old.filter(filter => item.id !== filter.id));
        }).catch(error => {
            showError(error.response.data.message || "خطایی رخ داد");
        });
    };
    const openDeleteDialog = async (rowData) => {
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

        confirmDialog({
            message: 'آیا از حذف آیتم اطمینان دارید؟',
            header: 'حذف آیتم',
            defaultFocus: 'reject',
            maskClassName: 'flex',
            headerClassName: '!pr-1 !pl-1',
            acceptClassName: 'btn btn-danger mx-1',
            rejectClassName: 'btn btn-secondary mx-1',
            acceptLabel: 'حذف',
            rejectLabel: 'انصراف',
            resizable: false,
            accept: () => {
                deleteItem(rowData)
                document.body.style.overflow = 'auto';
            },
            reject: () => {
                document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول
            },
        });
    };



    const actionTemplate = (rowData) => {
        return (
            <div className='d-flex justify-content-center gap-2' style={{ borderRight: '0.5px solid #D2D2D2' }}>
                <img
                    src={Edit}
                    alt="edit"
                    className="cursor-pointer mx-1"
                    onClick={() => openEditDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
                <img
                    src={Trash}
                    alt="delete"
                    className="cursor-pointer mx-1"
                    onClick={() => openDeleteDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
            </div>
        );
    };
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {
            if (imagePreview.length >= 1) {
                showError('حداکثر تعداد عکس ها 1 عدد است');
                return;
            }

            // Append new files
            const newFiles = acceptedFiles.slice(0, 1 - uploadedFile.length); // Limit to the remaining count
            const updatedFiles = [...uploadedFile, ...newFiles];
            setUploadedFile(updatedFiles);

            // Clear previews and set new previews
            const newPreviews = newFiles.map(file => URL.createObjectURL(file));
            let newPreviewsValue = [...imagePreview, ...newPreviews];
            setImagePreview(newPreviewsValue);
        },

        accept: 'image/*',
        maxFiles: 1 // Limit to a maximum of 1 files
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(uploadedFile.length == 0){
            showError("لطفا عکس را وارد کنید.");
            return
        }
        if(text == ''){
            showError("لطفا متن را وارد کنید.");
            return
        }
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
        let data = {
            "body": text,
            "summery": title,
            "readTime": readingTime,
            "createUserId": 0,
            "isActive": typeof status === "string" ? JSON.parse(status) : status,
            typeId,
            showInLandingPage
        };
        if (uploadedFile.length > 0) {
            data["fileBase64"] = await getRawBase64Data(uploadedFile[0]);
        }
        setLoading(true);
        await CreateWeblogAndNews(data)
            .then((response) => {
                loadPage();
                closeAddDialog();
                showSuccess("عملیات با موفیقت انجام شد");
            })
            .catch((error) => {
                showError(error.response?.data?.message || "خطایی رخ داد");
            })
            .finally(() => {
                setLoading(false);
            });}else{
                setAddFormValidated(true)
            }
    }

    const handleSubmitEdit = async (e) => {
        e.preventDefault();
        if(imagePreview.length == 0){
            showError("لطفا عکس را وارد کنید.");
            return
        }
        if(text == ''){
            showError("لطفا متن را وارد کنید.");
            return
        }
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
        setLoading(true)

        const convertToBase64 = async (file) => {
            return await toBase64(file).then(result =>
                result.substr(result.indexOf(",") + 1)
            );
        };

        // Initialize fileBase64
        let fileBase64 = null;

        if (imagePreview.length > 0) {
            // Fetch the file from the logoPath and convert to Base64
            try {
                const response = await fetch(imagePreview[0]); // Assuming `logoPath` is a URL
                const blob = await response.blob();
                fileBase64 = await convertToBase64(blob);
            } catch (error) {
                console.error("Error converting logoPath to Base64:", error);
                showError("مشکلی در تبدیل لوگو به Base64 وجود دارد.");
                setLoading(false);
                return;
            }
        }

        let data = {
            body: text,
            summery: title,
            readTime: readingTime,
            createUserId: 0,
            isActive: typeof status === "string" ? JSON.parse(status) : status,
            typeId,
            showInLandingPage,
            id: idNews,
            fileBase64: fileBase64
        };


        await UpdateWeblogAndNews(data)
            .then((response) => {
                loadPage();
                closeEditDialog();
                setLoading(false)

                showSuccess("عملیات با موفیقت انجام شد");
            })
            .catch((error) => {
                setLoading(false)
                showError(error.response?.data?.message || "خطایی رخ داد");
            })
            .finally(() => {
                setLoading(false);
            });}else{
                setEditFormValidated(true)
            }
    }

    const handleRemoveImage = (index) => {
        setUploadedFile([]);
        setImagePreview([]);
    };

    const handleEdit = (rowData) => {
        console.log('Editing:', rowData);
        setEditVisible(true);
        document.body.style.overflow = 'hidden';
    };

    const handleDelete = (rowData) => {
        console.log('Deleting:', rowData);
    };
    const indexGetter = (_, row) => {
        return row.rowIndex + 1;
    };
    const renderHTML = (rowData) => {
        const textContent = rowData.body.replace(/<[^>]+>/g, ''); // حذف تگ‌های HTML
        return (
            <div
                style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '150px',
                    marginLeft: 'auto',
                    marginRight: 'auto'

                }}
                title={textContent} // نمایش متن کامل در tooltip
            >
                {textContent}
            </div>
        );
    };
    return (
        <>
            <div className='w-100 d-flex justify-content-between bg-white p-2 align-items-center border-solid border'>
                <h6 className='font-bold text-sm mb-0'>اخبار</h6>
                <button className='btn btn-primary' onClick={openAddDialog}>تعریف خبر</button>
            </div>
            <div className=''>
                <DataTable value={items} size='small' lazy={true} tableStyle={{ minWidth: '50rem' }}>
                    <Column header="ردیف" body={indexGetter}></Column>
                    <Column field="summery" header="نام خبر" ></Column>
                    <Column field="body" header="عنوان خبر" body={renderHTML}></Column>
                    <Column field="readTime" header="مدت زمان مطالعه" ></Column>
                    <Column header="وضعیت" body={statusSwitchTemplate}></Column>
                    <Column header="عملیات" body={actionTemplate} ></Column>
                </DataTable>
            </div>

            {/* add category  */}
            <Dialog header="تعریف خبر" visible={addVisible} className='p-dialog-maximized' style={{ width: '100vw', height: '100vh' }} onHide={() => { if (!addVisible) return; closeAddDialog(); }}>
                <div className='dialog-body mx-4'>
                    <Form noValidate validated={addFormValidated} className='mt-3' action='#' onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="blogContent">
                            <Form.Label>متن نمونه</Form.Label>
                            <ReactQuill
                                theme="snow"
                                value={text}
                                onChange={setText}
                                modules={quillModules}
                                formats={quillFormats}
                                style={{ minHeight: '200px' }}
                            />
                        </Form.Group>
                        <div className='d-flex align-items-center justify-content-between'>
                            <Form.Group className="mb-3 w-1/3 px-2" controlId="exampleForm.ControlInput1">
                                <Form.Label>عنوان خبر</Form.Label>
                                <Form.Control type="text" required value={title} onChange={(e) => setTitle(e.target.value)} />
                                <Form.Control.Feedback type="invalid">
                            عنوان را وارد کنید
                        </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3 w-1/3 px-2" controlId="exampleForm.ControlTextarea1">
                                <Form.Label>زمان مطالعه</Form.Label>
                                <Form.Control type="number" required value={readingTime} onChange={(e) => setReadingTime(e.target.value)} />
                                <Form.Control.Feedback type="invalid">
                            زمان مطالعه را وارد کنید
                        </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3 w-1/3 px-2" controlId="exampleForm.status">
                                <Form.Label>وضعیت</Form.Label>
                                <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
                                    <option value={true}>فعال</option>
                                    <option value={false}>غیر فعال</option>
                                </Form.Select>
                            </Form.Group>


                        </div>
                        <Form.Group className="px-2 flex justify-start gap-2" controlId="exampleForm.showInLandingPage">
                            <Form.Label className='!w-auto !font-bold'>نمایش در صفحه اصلی</Form.Label>
                            <InputSwitch
                                checked={showInLandingPage}
                                onChange={(e) => setShowInLandingPage(e.value)}
                            />
                        </Form.Group>
                        <div className="upload-box mt-4 mb-0 flex-1" {...getRootProps()} style={{ borderRadius: '8px', minHeight: '112px', minWidth: '112px' }}>
                            <input {...getInputProps()} />
                            <div>
                                <div>
                                    <img src={Upload} alt="" className='mx-auto' />

                                    <p className='text-xs mt-2 font-medium'>آپلود بنر خبر</p>
                                    <h6 className='text-[10px]'>بهترین ابعاد: 280 * 280</h6>
                                    <h6 className='text-[10px]'>ماکزیمم حجم تصویر: ...</h6>
                                </div>


                            </div>
                        </div>
                        <div className='d-flex gap-2 align-items-center mb-2' style={{ flexWrap: 'wrap' }}>
                            {
                                imagePreview.length > 0 &&
                                <div className="image-preview-container d-flex gap-2" style={{ flexWrap: 'wrap' }}>
                                    {imagePreview.map((image, index) => (
                                        <div className='list-defult'>

                                            <div className='d-flex align-items-center gap-2 mt-4' style={{ flexWrap: 'wrap' }}>
                                                <div className='upload-file-btn'>
                                                    <img src={image} alt="Uploaded preview" className="image-preview" />
                                                    <div className='upload-file-btn-bottom'>
                                                        <div>
                                                            <img src={Trash} alt="" onClick={() => handleRemoveImage(index)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    ))}
                                </div>

                            }

                        </div>

                        <div className="flex justify-center gap-2 mt-4">
                            <button type="submit" disabled={loading} className="btn btn-primary flex-1 ">تایید و ثبت {loading && <Loader />}</button>
                            <button type="button" disabled={loading} className="btn btn-light border-[1px] !border-[#669D24] !text-[#669D24] flex-1" onClick={closeAddDialog}>انصراف</button>
                        </div>
                    </Form>
                </div>
            </Dialog>



            {/* Edit popup  */}
            <Dialog header="ویرایش خبر" visible={editvisible} className='p-dialog-maximized' style={{ width: '100vw', height: '100vh' }} onHide={() => { if (!editvisible) return; closeEditDialog(); }}>
                <div className='dialog-body mx-4'>
                    <Form noValidate validated={editFormValidated} className='mt-3' onSubmit={handleSubmitEdit}>
                        <Form.Group className="mb-3" controlId="blogContent">
                            <Form.Label>متن نمونه</Form.Label>
                            <ReactQuill
                                theme="snow"
                                value={text}
                                onChange={setText}
                                modules={quillModules}
                                formats={quillFormats}
                                style={{ minHeight: '200px' }}
                            />
                        </Form.Group>
                        <div className='d-flex align-items-center justify-content-between'>
                            <Form.Group className="mb-3 w-1/3 px-2" controlId="exampleForm.ControlInput1">
                                <Form.Label>عنوان خبر</Form.Label>
                                <Form.Control type="text" required value={title} onChange={(e) => setTitle(e.target.value)} />
                                <Form.Control.Feedback type="invalid">
                                    عنوان را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3 w-1/3 px-2" controlId="exampleForm.ControlTextarea1">
                                <Form.Label>زمان مطالعه</Form.Label>
                                <Form.Control type="number" required value={readingTime} onChange={(e) => setReadingTime(e.target.value)} />
                                <Form.Control.Feedback type="invalid">
                                    زمان مطالعه را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3 w-1/3 px-2" controlId="exampleForm.status">
                                <Form.Label>وضعیت</Form.Label>
                                <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
                                    <option value={true}>فعال</option>
                                    <option value={false}>غیر فعال</option>
                                </Form.Select>
                            </Form.Group>


                        </div>
                        <Form.Group className="px-2 flex justify-start gap-2" controlId="exampleForm.showInLandingPage">
                            <Form.Label className='!w-auto !font-bold'>نمایش در صفحه اصلی</Form.Label>
                            <InputSwitch
                                checked={showInLandingPage}
                                onChange={(e) => setShowInLandingPage(e.value)}
                            />
                        </Form.Group>
                        <div className="upload-box mt-4 mb-0 flex-1" {...getRootProps()} style={{ borderRadius: '8px', minHeight: '112px', minWidth: '112px' }}>
                            <input {...getInputProps()} />
                            <div>
                                <img src={Upload} alt="" className='mx-auto' />
                                <p className='text-xs mt-2 font-medium'>آپلود بنر خبر</p>
                                <h6 className='text-[10px]'>بهترین ابعاد: 280 * 280</h6>
                                <h6 className='text-[10px]'>ماکزیمم حجم تصویر: ...</h6>
                            </div>

                        </div>
                        <div className='d-flex gap-2 align-items-center mb-2' style={{ flexWrap: 'wrap' }}>

                            {
                                imagePreview.length > 0 &&
                                <div className="image-preview-container d-flex gap-2" style={{ flexWrap: 'wrap' }}>
                                    {imagePreview.map((image, index) => (
                                        <div className='list-defult'>

                                            <div className='d-flex align-items-center gap-2 mt-4' style={{ flexWrap: 'wrap' }}>
                                                <div className='upload-file-btn'>
                                                    <img src={image} alt="Uploaded preview" className="image-preview" />
                                                    <div className='upload-file-btn-bottom'>

                                                        <div>
                                                            <img src={Trash} alt="" onClick={() => handleRemoveImage(index)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    ))}
                                </div>


                            }

                        </div>

                        <div className="flex justify-center gap-2 mt-2">
                            <button type="submit" disabled={loading} className="btn btn-primary flex-1">تایید و ثبت {loading && <Loader />}</button>
                            <button type="button" disabled={loading} className="btn btn-light border-[1px] !border-[#669D24] !text-[#669D24] flex-1" onClick={closeEditDialog}>انصراف</button>
                        </div>
                    </Form>
                </div>
            </Dialog>
        </>
    );
}

export default Banner;
